<template>
  <div>
    <div class="common-level-rail">
      <el-button size="small" type="primary" @click="addClick()">添加</el-button>
      <el-button size="small" type="primary" @click="shuaixn()">刷新</el-button>
    </div>
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">

        <el-form-item label="id"><el-input size="small" v-model="searchForm.id"
            placeholder="请输入id"></el-input></el-form-item>

        <el-form-item label="地区"><el-input size="small" v-model="searchForm.name"
            placeholder="请输入地区"></el-input></el-form-item>

        <el-form-item label="所属地区"><el-input size="small" v-model="searchForm.pid"
            placeholder="请输入所属地区"></el-input></el-form-item>

        <el-form-item label="风险等级">
          <el-input size="small" v-model="searchForm.diqu" placeholder="请输入所属地区"></el-input>
        </el-form-item>

        <el-form-item><el-button size="small" type="primary" icon="el-icon-search"
            @click="onSubmit">查询</el-button></el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="id" label="ID"></el-table-column>
          <el-table-column prop="name" label="名称"></el-table-column>
          <el-table-column prop="pid_name" label="所属地区"></el-table-column>
          <el-table-column prop="diqu" label="状态"></el-table-column>
          <el-table-column fixed="right" label="操作" width="200">
            <template slot-scope="scope">
              <el-button @click="gobainji(scope.row)" type="success" size="small">编辑</el-button>
              <el-button @click="godelete(scope.row)" type="danger" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
          :current-page="curPage" :page-sizes="[10, 20, 50, 100]" :page-size="10"
          layout="total, sizes,prev, pager, next, jumper" :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>

    <el-dialog :title="title" :visible.sync="dialogVisiblefxdq" width="50%" :before-close="handleClose">
      <div class="tjfxdq">
        <div>
          <span> 名称:</span>
          <el-input v-model="input1" placeholder="请输入内容"></el-input>
        </div>

        <div>
          <span> 地区单位:</span>
          <el-select v-model="input4" placeholder="请选择">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>

        <div>
          <span> 所属地区ID:</span>
          <div> <el-input v-model="input2" placeholder="请输入内容"></el-input></div>
         
        </div>
        <div>
          <span> 状态:</span>
          <!-- <el-input v-model="input3" placeholder="请输入内容"></el-input> -->
          <el-select v-model="input3" placeholder="请选择">
            <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="anniu">
        <el-button @click="dialogVisiblefxdq = false">取 消</el-button>
        <el-button type="primary" @click="queding()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
  
<script>
import RegionalApi from "@/api/Regional.js";
export default {
  data() {
    return {
      id: "",
      title: "",
      tankuang: "",
      input1: "",
      input2: "",
      input3: "",
      input4: "",
      dialogVisiblefxdq: false,
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      searchForm: {
        id: "",
        pid: "",
        diqu: "",
        name: "",
        level: ""
      },
      // 省市区数据
      options: [{
          value: 1,
          label: '省'
        }, {
          value: 2,
          label: '市'
        }, {
          value: 3,
          label: '区'
        }
      ],
       // 风险值数据
       options2: [{
          value: '高度风险',
          label: '高度风险'
        }, {
          value: '中度风险',
          label: '中度风险'
        }, {
          value: '低度风险',
          label: '低度风险'
        }
      ],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    shuaixn() {
      this.loading = true;
      this.getData();
    },
    queding() {
      if (this.tankuang == 1) {
        console.log(this.input1, this.input2, this.input3,this.input3,"添加");
        let Params = {
          name: this.input1,
          pid_name: this.input2,
          diqu: this.input3,
          level:this.input4
        };
        RegionalApi.addRegion(Params, true).then((res) => {
          console.log(res, "table");
          this.$message({
            type: "success",
            message: "添加成功",
          });
          this.dialogVisiblefxdq = false;
          this.getData();
        });
      } else {
        console.log(this.input1, this.input2, this.input3, this.input4,this.id, "编辑");
        let Params = {
          name: this.input1,
          pid: this.input2,
          diqu: this.input3,
          id: this.id,
          level:this.input4
        };
        RegionalApi.editRegion(Params, true).then((res) => {
          console.log(res, "table");
          this.$message({
            type: "success",
            message: "修改成功",
          });
          this.dialogVisiblefxdq = false;
          this.getData();
        });
      }
    },
    // 添加
    addClick() {
      // console.log("添加", row);
      // 添加等于1;
      this.dialogVisiblefxdq = true;
      this.tankuang = 1;
      this.title = "添加风险地区";
    },
    // 删除
    godelete(row) {
      console.log("删除", row.id);
      this.$confirm("确定要删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info ",
      })
        .then(() => {
          let Params = {
            id: row.id,
          };
          RegionalApi.deleteRegion(Params, true).then((res) => {
            console.log(res, "table");
            this.$message({
              type: "success",
              message: "删除成功",
            });
            this.getData();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 打开编辑
    gobainji(row) {
      console.log("编辑", row.diqu,row.pid_name,row.name,row.level);
      this.input1 = row.name;
      this.input2 = row.pid;
      this.input3 = row.diqu;
      this.input4 = row.level;
      this.id = row.id;
      // 编辑等于2;
      this.dialogVisiblefxdq = true;
      this.tankuang = 2;
      this.title = "编辑风险地区";
    },
    // 弹窗关闭
    handleClose() {
      this.dialogVisiblefxdq = false;
      this.input1 = "";
      this.input2 = "";
      this.input3 = "";
      this.input4 = "";
    },
    /*获取数据*/
    getData() {
      let Params = this.searchForm;
      Params.dataType = this.activeName;
      Params.page = this.curPage;
      Params.list_rows = this.pageSize;
      this.loading = true;
      RegionalApi.indexRegion(Params, true).then((res) => {
        this.loading = false;
        console.log(res.data.list.data, "table");
        this.tableData = res.data.list.data;
        this.totalDataNumber = res.data.list.total;
      });
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      console.log(val);
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      self.loading = true;
      this.getData();
    },
    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.tableData = [];
      this.getData();
    },
  },
};
</script>
  
<style lang="scss">
.tjfxdq {
  margin-bottom: 15px;
}

.tjfxdq div {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 5px;
}

.tjfxdq div span {
  width: 100px;
}

.tjfxdq div div {
  width: 600px;
}

.anniu {
  display: flex;
  justify-content: flex-end;
}
</style>


// WEBPACK FOOTER //
// src/views/setting/region/indexregion.vue